import ReactPlayer from "react-player";
import { ReactComponent as PlayButton } from "../../Assets/Icons/play_button.svg";
import { ReactComponent as PlayButton2 } from "../../Assets/Icons/play2.svg";
import { ReactComponent as Audio } from "../../Assets/Icons/audio.svg";
import shortenText from "../../utils/shortenText";
import clsx from "clsx";
const VideoPlayer = ({
  video,
  isPlaying,
  playVideoHandler,
  stopVideoHandler,
  variant = "normal",
  showTitle = true,
  controls = true,
}) => {

  const playVideo = (videoParams) => {
    playVideoHandler(videoParams);
  };

  const stopVideo = () => {
    if(stopVideoHandler){
      stopVideoHandler();
    }
  };

  return (
    <>
      {!!video && (
        <div className="relative w-full h-full">
          <ReactPlayer
            playIcon={<div></div>}
            width="100%"
            height="100%"
            onEnded={() => stopVideo(video)}
            url={video?.content?.youtube_link}
            playing={isPlaying}
            controls={controls}
          />
          {!isPlaying && (
            <button
              onClick={() => playVideo(video)}
              type="button"
              className={clsx({
                "cursor-pointer flex  flex-col outline-none focus:outline-none   absolute top-0 left-0 right-0 bottom-0 w-full": true,
                "bg-gradient1 bg-opacity-10": variant === "normal",
                "bg-home-resource": variant === "dark",
              })}
            >
              <span className="flex-grow flex items-center justify-center w-full">
                <span className="w-6 h-6 md:w-12 md:h-12 lg:w-12 lg:h-12">
                  {variant === "normal" && video.type === "video" && (
                    <PlayButton />
                  )}
                  {variant === "dark" && video.type === "video" && (
                    <PlayButton2 />
                  )}
                  {video?.type === "audio" && <Audio />}
                </span>
              </span>
              <span className="p-3 md:p-6 inline-block flex-shrink-0 absolute bottom-0 text-10px font-poppins font-semibold text-white leading-4 text-left md:text-lg md:leading-34">
                {showTitle && !!video?.name
                  ? shortenText(video.name, 150)
                  : ""}
              </span>
            </button>
          )}
        </div>
      )}
    </>
  );
};

export default VideoPlayer;
